import { Link } from "react-router-dom";
import { useOrders } from "../hooks/useOrders";
import { useAuthPrincipal } from "../hooks/useAuthPrincipal";
import { OrdersTable } from "../components/OrdersTable";
import { ErrorBanner, LoadingState } from "../components/States";

export function BuyerOrdersPage() {
  const { principal } = useAuthPrincipal();
  const { data, isLoading, isError, error, refetch } = useOrders();

  const myPurchases =
    data?.items.filter((order) => order.buyerWalletId === principal?.walletId) ?? [];

  return (
    <div className="stack">
      <div className="row row--between">
        <h1>My purchases</h1>
        <Link to="/offers" className="btn btn-secondary">
          My offers
        </Link>
      </div>
      {isLoading && <LoadingState label="Loading your orders…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}
      {data && <OrdersTable orders={myPurchases} emptyLabel="You haven't bought anything yet." />}
    </div>
  );
}
